import { ArrowBack } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

const MobileHeader = ({
    breadcrumbs = [],
    title,
    titleIcon,
    moreButton,
}: {
    title: ReactNode;
    breadcrumbs?: Array<{
        label: string;
        onClick?: () => void;
        href?: string;
    }>;
    titleIcon?: ReactNode;
    moreButton?: ReactNode;
}) => {
    const previousBreadcrumb = breadcrumbs?.[breadcrumbs.length - 2];

    return (
        <Stack
            p={2}
            justifyContent='space-between'
            alignItems='center'
            direction='row'
            sx={{
                background: '#F5F5F5',
            }}
            m={-2}
        >
            <Stack spacing={1} direction='row' alignItems='center'>
                {previousBreadcrumb && (
                    <IconButton
                        onClick={() => {
                            if (previousBreadcrumb) {
                                previousBreadcrumb.onClick?.();
                            }
                        }}
                        color='primary'
                    >
                        <ArrowBack />
                    </IconButton>
                )}
                <Typography variant='h5' color='primary' sx={{ wordBreak: 'break-word' }}>
                    {title}
                </Typography>
                {titleIcon}
            </Stack>
            {moreButton}
        </Stack>
    );
};

export default MobileHeader;
